import React from "react";
import { motion } from "framer-motion";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "./GlassyButton.css";

const GlassyButton = ({
  text,
  IconComponent,
  ArrowIconComponent = ArrowForwardIcon,
  onClick,
  href,
  className = "",
}) => {
  const buttonContent = (
    <>
      {IconComponent && (
        <div className="glassy-button-icon">
          {/* This will now render the passed MUI icon */}
          <IconComponent />
        </div>
      )}

      <motion.span
        initial={{ color: "#fff" }}
        variants={{ hover: { color: "#222" } }}
        className="glassy-button-text"
      >
        {text}
      </motion.span>

      <motion.span
        className="glassy-arrow-icon-bg"
        variants={{ hover: { x: 5 } }}
        transition={{ type: "spring", stiffness: 300 }}
      >
        <ArrowIconComponent />
      </motion.span>

      <motion.div
        className="glassy-button-hover-bg"
        variants={{ hover: { scaleX: 1, originX: 0 } }}
        initial={{ scaleX: 0 }}
        transition={{ duration: 0.4, ease: [0.43, 0.13, 0.23, 0.96] }}
      />
    </>
  );

  const commonProps = {
    className: `glassy-button ${className}`,
    whileHover: "hover",
  };

  if (href) {
    return (
      <motion.a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        {...commonProps}
      >
        {buttonContent}
      </motion.a>
    );
  }

  return (
    <motion.button onClick={onClick} {...commonProps}>
      {buttonContent}
    </motion.button>
  );
};

export default GlassyButton;
